import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";
import { isValidDate } from "@utils/dateValidation";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Patient } from "@customTypes/patient";

import { patientQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  if (Object.keys(res.data).length) {
    const newData = {} as Patient;

    const {
      _id,
      patient_id,
      first_name,
      middle,
      surname,
      dob,
      gender,
      email,
      phone_number,
      alternate_phone,
      emergency_name,
      emergency_contact,
      emergency_relationship,
      emergency_country,
      height,
      weight,
      blood_type,
      Job,
      drinking_habits,
      Exercise,
      Diet,
      Smoke,
      BillingCard,
      Policy_Number,
      Provider,
      Expiry,
      donor,
      country,
      city,
      state,
      zone,
    } = res.data;

    newData.id = _id;
    newData.patientId = patient_id;
    newData.firstName = first_name;
    newData.middleName = middle;
    newData.surname = surname;
    newData.dob = isValidDate(dob) ? dob : new Date(1900, 0, 1, 0, 0);
    newData.gender = gender?.toLocaleLowerCase()?.startsWith("f")
      ? "female"
      : gender?.toLocaleLowerCase()?.startsWith("m")
      ? "male"
      : "";
    newData.email = email;
    newData.phoneNumber = phone_number;
    newData.altPhoneNumber = alternate_phone;
    newData.country = country;
    newData.state = state;
    newData.city = city;
    newData.zone = zone;
    newData.emergencyContactName = emergency_name;
    newData.emergencyContactPhoneNumber = emergency_contact;
    newData.emergencyContactRelationship = emergency_relationship;
    newData.emergencyContactCountry = emergency_country;
    newData.height = height;
    newData.weight = weight;
    newData.bloodType = blood_type;
    newData.bloodDonor = donor === true ? "yes" : "no";
    newData.occupation = Job;
    newData.drinkingHabits = drinking_habits;
    newData.exerciseFrequency = Exercise;
    newData.diet = Diet;
    newData.smokingHabits = Smoke;
    newData.insuranceType = BillingCard;
    newData.insurancePolicyNumber = Policy_Number;
    newData.insuranceProvider = Provider;
    newData.insuranceExpiry = isValidDate(Expiry) ? Expiry : "";

    // console.log(newData);
    return newData;
  }
  return null;
};

interface QueryProps {
  patientId: string;
  isEnabled?: boolean;
  reason?: string;
}

export const useGetSinglePatient = ({
  patientId,
  isEnabled = true,
  reason,
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: patientQKeys.singlePatient(patientId),
    queryFn: () => {
      // console.log("reason in query param", reason);
      return api.get(`patient/${patientId}`, { params: { reason } });
    },
    select,
    enabled: isEnabled,
    onError: (res: any) => {
      console.error("[From Get Single Patient]", res);
      handleErrors(res, "query");
    },
  });
};
